<template>
  <div class="page flex-col">
    <div class="block_1 flex-col">
      <div class="group_1 flex-row">
        <img
          class="label_1"
          referrerpolicy="no-referrer"
          src="./assets/img/FigmaDDSSlicePNGe909db0921cf6fdf268e6d7557656c70.png"
        />
        <span class="text_1">虹猫AI</span>
      </div>
    </div>
    <div class="block_2 flex-col">
      <div class="box_1 flex-row justify-between">
        <div class="image-text_1 flex-col justify-between">
          <img
            class="image_1"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG38fdf2f0c3e1f12e9ba673d6cf4e413d.png"
          />
          <span class="text-group_1">卡通人物</span>
        </div>
        <div class="block_3 flex-col justify-between">
          <img
            class="image_2"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG798825e02bdc1279cd4a38c0903e639f.png"
          />
          <span class="text_2">先遣队</span>
        </div>
        <div class="block_4 flex-col justify-between">
          <img
            class="image_3"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG3feee67ca1d29bf3ab86f7bdd8e0ae80.png"
          />
          <span class="text_3">近期更新</span>
        </div>
        <div class="block_5 flex-col justify-between">
          <img
            class="image_4"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG175e2912a82135ca8e01f72d07bd0461.png"
          />
          <span class="text_4">女频分类</span>
        </div>
        <div class="block_6 flex-col justify-between">
          <img
            class="image_5"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNGbca9bb9cef0cbf56bab9f455cd7f61f5.png"
          />
          <span class="text_5">都市人物</span>
        </div>
        <div class="block_7 flex-col justify-between">
          <img
            class="image_6"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG41b3376cf7776af17665e9c1402c8518.png"
          />
          <span class="text_6">修仙玄幻</span>
        </div>
        <div class="block_8 flex-col justify-between">
          <img
            class="image_7"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG4d9f26274cf33e0e93e13e71cc910b70.png"
          />
          <span class="text_7">历史人物</span>
        </div>
        <div class="block_9 flex-col justify-between">
          <img
            class="image_8"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG4eabb1c450dd05fab43a6611d79843a9.png"
          />
          <span class="text_8">悬疑灵异</span>
        </div>
        <div class="block_10 flex-col justify-between">
          <img
            class="image_9"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNGd10c0fffc1f72e9c82ee6ad7f62ee84f.png"
          />
          <span class="text_9">同人集合</span>
        </div>
        <div class="block_11 flex-col justify-between">
          <img
            class="image_10"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG41b3376cf7776af17665e9c1402c8518.png"
          />
          <span class="text_10">妖怪灵兽</span>
        </div>
        <div class="block_12 flex-col justify-between">
          <img
            class="image_11"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG98aa84a3e0acde95865db4470e24f13d.png"
          />
          <span class="text_11">场景合集</span>
        </div>
        <div class="block_13 flex-col justify-between">
          <img
            class="image_12"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNGdf5b1b9c78b153b0d81f42d5b7c58ac1.png"
          />
          <span class="text_12">物件合集</span>
        </div>
        <div class="block_14 flex-col justify-between">
          <img
            class="image_13"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG73af1aac1895811916c4d599bdd56c76.png"
          />
          <span class="text_13">路人合集</span>
        </div>
        <div class="block_15 flex-col justify-between">
          <img
            class="image_14"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNGdbd7e3163f6a1578b3d260df67636e79.png"
          />
          <span class="text_14">特效合集</span>
        </div>
      </div>
      <div class="text-wrapper_1 flex-row">
        <span class="text_15">
          Copyright&nbsp;2025&nbsp;虹猫AI技术有限公司.&nbsp;All&nbsp;Rights&nbsp;Reserved&nbsp;浙ICP备xxxxx号
        </span>
      </div>
      <div class="box_2 flex-col"></div>
      <div class="box_3 flex-col"></div>
      <div class="box_4 flex-col">
        <div class="text-wrapper_2 flex-col"><span class="text_16">登录</span></div>
        <div class="section_1 flex-row justify-between">
          <div class="group_2 flex-col">
            <span class="text_17">虹猫&nbsp;素材网</span>
            <img
              class="image_15"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNGfed3ea6f378441db0fbb23d39ee7c0a1.png"
            />
            <span class="text_18">下载的不止是素材，是故事的开始！</span>
          </div>
          <img
            class="image_16"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG6fcc2a468bc54aa0a3d966eddbfce04d.png"
          />
        </div>
        <div class="section_2 flex-col">
          <div class="group_3 flex-row justify-between">
            <div class="box_5 flex-col justify-between">
              <span class="text_19">修仙老虎人</span>
              <div class="block_16 flex-row justify-between">
                <div class="section_3 flex-row">
                  <div class="image-text_2 flex-row justify-between">
                    <img
                      class="thumbnail_1"
                      referrerpolicy="no-referrer"
                      src="./assets/img/FigmaDDSSlicePNGc3042183651983abe4ed904fedb6a659.png"
                    />
                    <span class="text-group_2">同人合集</span>
                  </div>
                </div>
                <div class="text-wrapper_3">
                  <span class="text_20">2025-09-09&nbsp;·&nbsp;454</span>
                  <span class="text_21">人围观</span>
                </div>
              </div>
            </div>
            <div class="box_6 flex-row">
              <div class="image-text_3 flex-row justify-between">
                <img
                  class="thumbnail_2"
                  referrerpolicy="no-referrer"
                  src="./assets/img/FigmaDDSSlicePNG7ac7c833b1ac15280ee0df46fbb4de1f.png"
                />
                <span class="text-group_3">下载</span>
              </div>
            </div>
          </div>
          <div class="image-wrapper_1 flex-row">
            <img
              class="image_17"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNGd6606cf72c785d20950f52c20231eb98.png"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />